export default __webpack_public_path__ + "static/media/favicon.568e0901.ico";